import { render, staticRenderFns } from "./detailDefault.vue?vue&type=template&id=1b4f22fc&scoped=true"
import script from "./detailDefault.vue?vue&type=script&lang=js"
export * from "./detailDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4f22fc",
  null
  
)

export default component.exports